import { render, staticRenderFns } from "./TableMedicine.vue?vue&type=template&id=5a22f828&scoped=true"
import script from "./TableMedicine.vue?vue&type=script&lang=js"
export * from "./TableMedicine.vue?vue&type=script&lang=js"
import style0 from "./TableMedicine.vue?vue&type=style&index=0&id=5a22f828&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a22f828",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/node-apps/im.ingenes.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a22f828')) {
      api.createRecord('5a22f828', component.options)
    } else {
      api.reload('5a22f828', component.options)
    }
    module.hot.accept("./TableMedicine.vue?vue&type=template&id=5a22f828&scoped=true", function () {
      api.rerender('5a22f828', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TableMedicine.vue"
export default component.exports